import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKeyhole2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="keyhole-2, lock, unlock"><path d="M5.75 9C5.75 11.452 7.16205 13.5743 9.21736 14.5979L7 21.25H17L14.7826 14.5979C16.8379 13.5743 18.25 11.452 18.25 9C18.25 5.54822 15.4518 2.75 12 2.75C8.54822 2.75 5.75 5.54822 5.75 9Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconKeyhole2;
